module.exports = __webpack_public_path__ + "static/media/icon-title-alert-close.af2aefe4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/AlertTranslation/assets/icon-title-alert-close.svg
// module id = 1605
// module chunks = 193